import { Component } from "react";
import html2pdf from 'html2pdf.js';


class VoucherGenerator extends Component{
    state = {show:'visible',buttonshow:'collapse'};


    handleSingleInput= (e)=>{
        const others = {...this.state.others};
        others[e.target.name] = e.target.value;
        
        this.setState({others},()=>{console.log('bobo',this.state)});
        
      }

    handleDownload = (filename) => {
        console.log("hallo bros")
          const element = document.getElementById('licences');
      
          html2pdf()
            .from(element)
            .set({
              margin: 0.5,
              filename: filename+' licences.pdf',
              image: { type: 'jpeg', quality: 0.98 },
              html2canvas: { scale: 2 },
              jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
            })
            .save();
        };

    generate = ()=>{
        const others = {...this.state.others};
        var vouchers = others.vouchers.split(' ');
        others['vouchersList'] = vouchers
        var show = this.state.show;
        var buttonshow = this.state.buttonshow;
        show = 'collapse';
        buttonshow = 'visible';
        this.setState({others, show, buttonshow},()=>{console.log('bobo',this.state)});
        console.log(others.vouchersList);
    } 
    render(){
        return <>
        <div >
            <div className="mycenterCenter" style={{
             visibility:this.state.show
        }}>
            <div className="card p-3 m-3">
             <div class="col-md-12">
                  <label for="inputtitle" class="form-label">Course Name</label>
                  <input type="text" id="inputtitle" className="form-control mb-3" name="title" onChange={this.handleSingleInput} required/>
                </div>
                <div class="col-md-12">
                  <label for="inputvoucher" class="form-label">All Vouchers</label>
                  <input type="text" name="vouchers" className="form-control mb-3" id="inputvoucher" onChange={this.handleSingleInput} required/>
                  {/* <textarea  id="inputvoucher" cols="40" rows="5" className="form-control mb-3" name="vouchers" onChange={this.handleSingleInput} required> </textarea> */}
                </div>
             {/* <input type="text" name="title" onChange={this.handleSingleInput} required/>
             <br />

        <input type="text" name="vouchers" onChange={this.handleSingleInput} required/>
        <br /> */}
       
        <button onClick={this.generate} > Generate</button>
        </div>
        </div> </div>
        <div style={{
            visibility:this.state.buttonshow,
            position: '-webkit-sticky', position: 'sticky',top: '10px',zIndex: '9999'
        }} >
            {/* style={{ position: '-webkit-sticky', position: 'sticky',top: '10px',zindex: '9999'}} */}
        <button   className="btn btn-info btn-lg px-5 text-white fw-bold"   onClick={()=>{this.handleDownload(this.state.others.title)}}>Download PDF</button>
        {/* <button type='submit'  className="btn btn-info btn-lg px-5 text-white fw-bold">Refer</button> */}
        </div>
        
        <div id="licences" >
        <div className="row">
        

        {this.state.others?.vouchersList!=null? this.state.others.vouchersList.map((e,i)=>
       
          
           <>
                <div className="col-4" style={{fontSize:"0.8em"}} >
                    <div className='card' style={{textAlign:"center",padding:'2px',height:'320px'}}>
                        {/* <small> {i+1} </small> */}
                    <hr />
                        {`${i+1}. ${this.state.others.title}${''
                            // e
                            // .substring(0, 6)
                            } `}
                            {}
                        <hr />
                        <h6>Steps:</h6>
                        <p >1. Visit "varsityreghub.com" <br />
                        2. Click on Course registration from the menu at the top.<br />
                        3. Follow all instructions and supply the licence number below when needed.</p>
                    <p style={{fontSize:"1em"}}><b>{e}</b></p>
                    </div>
                  { (i%9 === 0) && <div class="pagebreak"></div>}
            
            </div>
           
            </>
        
    ):[]}
     </div>
    </div>
        </>
    }
}

export default VoucherGenerator;